import { createTheme } from '@mui/material/styles';

/** Shared MUI theme. Clean, flat, professional admin palette. */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1a73e8' },
    secondary: { main: '#00897b' },
    background: { default: '#f6f8fa', paper: '#ffffff' },
    success: { main: '#34a853' },
    warning: { main: '#fa7b17' },
    error: { main: '#d93025' },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiAppBar: { defaultProps: { elevation: 0, color: 'default' } },
    MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { border: '1px solid #e0e0e0' } } },
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
